import { SystemLabel } from './system-label';
import { Variant } from '../../product/dto/variant';
import { SaleLabelFormat } from '../../enum/shared/sale-label-format.enum';
import { LocationPriceStream } from '../../enum/shared/location-price-stream';
import { PriceUtils } from '../../../utils/price-utils';

export class SaleSystemLabel extends SystemLabel {
  public getSaleText(
    [variant, priceStream, saleLabelFormat]: [Variant, LocationPriceStream, SaleLabelFormat],
    [themeId, locId, companyId]: [string, number, number],
    overrideBaseSaleFormatText?: string,
    overrideDollarOffSaleFormatText?: string,
    overridePercentOffSaleFormatText?: string
  ): string {
    switch (saleLabelFormat) {
      case SaleLabelFormat.SALE:
        return overrideBaseSaleFormatText || this.text || 'SALE';
      case SaleLabelFormat.DOLLAR_OFF:
        return overrideDollarOffSaleFormatText || this.getDollarOff(variant, themeId, locId, companyId, priceStream);
      case SaleLabelFormat.PERCENT_OFF:
        return overridePercentOffSaleFormatText || this.getPercentOff(variant, themeId, locId, companyId, priceStream);
    }
  }

  private getDollarOff(
    variant: Variant,
    themeId: string,
    locationId: number,
    companyId: number,
    priceStream: LocationPriceStream
  ): string {
    const originalPrice = variant?.getPriceWithoutDiscounts(themeId, locationId, companyId, priceStream);
    const salePrice = variant?.getDiscountedPriceOrNull(themeId, locationId, companyId, priceStream);
    const saved = originalPrice - salePrice;
    return Number.isFinite(saved) ? PriceUtils.formatPrice(saved) + ' OFF' : this.text || 'SALE';
  }

  private getPercentOff(
    variant: Variant,
    themeId: string,
    locationId: number,
    companyId: number,
    priceStream: LocationPriceStream
  ): string {
    const alteredPriceStream =
      priceStream === LocationPriceStream.TaxesInRounded ? LocationPriceStream.TaxesIn : priceStream;
    const originalPrice = variant?.getPriceWithoutDiscounts(themeId, locationId, companyId, alteredPriceStream);
    const salePrice = variant?.getDiscountedPriceOrNull(themeId, locationId, companyId, alteredPriceStream);
    const saved = 1 - salePrice / originalPrice;
    return Number.isFinite(saved) ? PriceUtils.formatDecimalIntoPercentage(saved) + ' OFF' : this.text || 'SALE';
  }
}
